import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const passedUser = location.state?.user;
  const [status, setStatus] = useState(passedUser ? (passedUser.is_admin ? "ok" : "forbidden") : "checking");

  useEffect(() => {
    if (passedUser) return;
    const check = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("unauth");
        const user = await res.json();
        setStatus(user.is_admin ? "ok" : "forbidden");
      } catch (e) {
        navigate("/login");
      }
    };
    check();
  }, [navigate, passedUser]);

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-midnight flex items-center justify-center text-gray-300">
        <Loader2 className="h-6 w-6 animate-spin mr-3" /> Checking access...
      </div>
    );
  }

  if (status === "forbidden") {
    return (
      <div className="min-h-screen bg-midnight flex items-center justify-center px-6 text-center">
        <div>
          <ShieldAlert className="h-12 w-12 text-gold mx-auto mb-5" strokeWidth={1.5} />
          <h1 className="font-heading text-2xl font-bold text-white mb-3">Access denied</h1>
          <p className="text-gray-400 font-light mb-6">This account is not authorised for the admin area.</p>
          <a href="/" className="text-gold font-semibold uppercase tracking-[0.12em] text-sm">Back to website</a>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
